import React from 'react'

import { CompanyProfileProvider } from '../../company-profile/contexts'
import { AdhesionOp } from './adhesion-op.component'

export const AdhesionOpComponent = () => {
  return (
    <CompanyProfileProvider>
      <AdhesionOp />
    </CompanyProfileProvider>
  )
}
